import { ProfileAvatar } from "@ui/ProfileAvatar";
import type { UserFullInfo } from "@entities/User/types/user.fullInfo";
import { PencilGlyph } from "./profile-glyphs";
import { getYearWord } from "./profile-formatters";

interface ProfileSummaryProps {
  avatarUrl?: string;
  userData: Partial<UserFullInfo>;
  onEditClick: () => void;
}

export const ProfileSummary = ({
  avatarUrl,
  userData,
  onEditClick,
}: ProfileSummaryProps) => {
  const firstName = userData.firstName || userData.username || "Профиль";
  const lastInitial = userData.lastName ? `${userData.lastName[0]}.` : "";
  const experienceLabel = userData.yearsExperience
    ? `более ${userData.yearsExperience} ${getYearWord(userData.yearsExperience)}`
    : "не указан";

  return (
    <section className="relative isolate mt-7 overflow-visible pb-3">
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute left-[124px] top-[-68px] z-0 h-[180px] w-[calc(100%_-_104px)] overflow-visible"
        viewBox="0 0 380 180"
        preserveAspectRatio="none"
      >
        <path
          d="M0 88C116 4 276 0 380 126"
          fill="none"
          stroke="#D8F34A"
          strokeOpacity="0.72"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </svg>
      <div className="relative z-10 grid grid-cols-[142px_minmax(0,1fr)] items-center gap-9">
        <div className="flex justify-center">
          <ProfileAvatar
            src={avatarUrl}
            width={148}
            height={148}
            style={{
              backgroundColor: "#F4F5F2",
            }}
          >
            <button
              type="button"
              onClick={onEditClick}
              aria-label="Редактировать профиль"
              className="flex size-10 items-center justify-center rounded-full bg-white text-[#15181B] shadow-[0_10px_18px_rgba(24,27,31,0.14)] transition-transform active:scale-[0.94]"
            >
              <PencilGlyph className="size-5" />
            </button>
          </ProfileAvatar>
        </div>

        <div className="min-w-0 pt-2">
          <h1 className="truncate pb-1 text-[43px] font-semibold leading-[1.08] tracking-normal text-[#15181B]">
            {firstName}{" "}
            <span className={"font-extralight text-[#3f3f3f]"}>
              {lastInitial}
            </span>
          </h1>
          {userData.lastName && (
            <div className="mt-3 inline-flex max-w-full rounded-full bg-[#F0F1EF] px-4 py-1 text-[14px] font-medium leading-none ">
              <span className="truncate text-[#686D62]">
                {userData.lastName}
              </span>
            </div>
          )}
          <div className="mt-5 space-y-1 text-[16px] font-medium leading-[1.15]">
            <p className="text-[#7D8287]">Опыт в тренировках:</p>
            <p className="text-[#B6DF00]">{experienceLabel}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
